<script>
    export let size = {
        width: 3,
        height: 3
    };

    export let color = "--third-text-color"
</script>

<svg class="dot" style="fill: var({color})" width={size.width} height={size.height} viewBox="0 0 3 3" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="1.5" cy="1.5" r="1.5" fill="#00000"/></svg>